import React from "react";
import { type GalleryLayout } from "~/features/blocks/inventory/gallery";
import { type Mode, type Theme } from "~/features/ui/get-theme-style";
type Props = {
  theme: Theme;
  mode: Mode;
  layout: GalleryLayout;
  hasInsetDividers: boolean;
};
export const GalleryBlockContext = React.createContext<Props | undefined>(undefined);
export const useGalleryBlock = () => {
  const context = React.useContext(GalleryBlockContext);
  if (context === undefined) {
    throw new Error("useGalleryBlock must be used within a GalleryBlockBlockProvider");
  }
  return context;
};